import cx from 'classnames';
import React from 'react';

import { Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ButtonLinkV2 } from 'src/components/Button/ButtonLinkV2';
import { Grid } from 'src/components/Grid/Grid';
import { Image } from 'src/components/Image/Image';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { useDesktopOrLarge, useMobile } from 'src/hooks/UseResponsive';
import { AppType, Image as ImageType, WithCMS, toEntry } from 'src/services/cms/typesUtil';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';
import { GridContainer } from '../GridContainer/GridContainer';

import styles from './HeroModule.scss';

type HeroModuleProps = AppType.Component<{
  headline: string;
  image: ImageType;
  mobileImage: ImageType;
  links?: Subject[];
  headlineColor?: string;
}>;

export const HeroModule: React.FC<HeroModuleProps> = ({
  headline,
  image,
  mobileImage,
  headlineColor,
  links,
  ...props
}) => {
  const isMobile = useMobile();
  const isDesktopOrLarge = useDesktopOrLarge();
  return (
    <section className={cx(styles.heroModule, styles.heroModuleSection)} {...props._attributes}>
      <GridContainer justifyContent={'flex-start'} className={styles.heroModuleContentContainer}>
        <Grid item xs={false} md={6} />
        <Grid item xs={11} md={6} lg={5} className={styles.heroModuleHeadlineContainer}>
          <TextV2
            hasId
            variant="h1-bold"
            tagName="h1"
            className={styles.heroModuleHeadline}
            value={headline}
            style={{ color: headlineColor }}
          />
        </Grid>
        <Grid xs={false} md={6} />
        <Grid item xs={12} md={6} lg={4} className={styles.heroModuleButtonContainer}>
          {links?.length && (
            <ul data-test={'headline-button-container'}>
              {links?.map((link, index) => (
                <li key={componentKeyV2(link, index)}>
                  <ButtonLinkV2
                    className={cx(styles.heroModuleButton, isDesktopOrLarge ? styles.heroModuleButtonLarge : '')}
                    entry={toEntry(link as WithCMS<Subject>)}
                  />
                </li>
              ))}
            </ul>
          )}
        </Grid>
      </GridContainer>
      <Image
        src={isMobile ? mobileImage?.file?.url : image?.file?.url}
        className={cx(styles.heroModuleImage)}
        role="presentation"
      />
    </section>
  );
};
